import React from 'react';
import { MapContainer } from '../components/Map/MapContainer';
import { AssessmentTool } from '../components/SiteAssessment/AssessmentTool';

export const AssessmentPage: React.FC = () => {
  return (
    <div className="h-full w-full flex">
      <div className="flex-1">
        <MapContainer />
      </div>
      <div className="w-96 bg-white border-l border-gray-200">
        <AssessmentTool />
      </div>
    </div>
  );
};
